import { useSnapshot } from 'valtio'
import cn from 'classnames'
import { type ReactElement, useEffect } from 'react'

import { useRouter } from 'next/router'
import { transactionProxy } from '../../../../../shared/proxies/transactionProxy'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'
import { PlaceholderBox } from '../../../../../shared/components/ui/PlaceholderBox'
import { ErrorBox } from '../../../../../shared/components/ui/ErrorBox'
import { executeTransactionRetrieveRelated } from '../../../../../shared/apiUtils/executeTransactionRetrieveRelated'
import { RelatedTransactionsRows } from './RelatedTransactionsRows'
import { RelatedTransactionsTableHeader } from './RelatedTransactionsTableHeader'

export function RelatedTransactionsTable (): ReactElement | null {
  const router = useRouter()
  const { id } = router.query
  const { apiCall, relatedTransactions, transaction } = useSnapshot(transactionProxy)
  const { siteTheme: { tableHeaderColors } } = useSnapshot(proxyGlobalAuth)

  useEffect(() => {
    const searchId = transaction?.relatedTransactionId ?? id
    if (!searchId) { return }
    void executeTransactionRetrieveRelated(searchId as string, id as string)
  }, [transaction, id])

  if (!relatedTransactions || relatedTransactions.length < 1) {
    return (<></>)
  }

  return (

    <PlaceholderBox loading={apiCall.loading} rows={40} rowHeight="h-5">
      <ErrorBox error={apiCall.error}>
        <div className={cn('flex flex-row shadow rounded p-4 w-full bg-white')}>
          <h2 className={cn(tableHeaderColors.secondaryFontClasses, 'text-xl text-left')}>
            Associated Transactions
          </h2>
        </div>
        <table className="w-full bg-white">
          <thead className="text-left">
            <tr>
              <RelatedTransactionsTableHeader title="ID" width={10} />
              <RelatedTransactionsTableHeader title="Date" width={10} />
              <RelatedTransactionsTableHeader title="Invoice" width={10} />
              <RelatedTransactionsTableHeader title="Status" width={15} />
              <RelatedTransactionsTableHeader title="Method" width={15} />
              <RelatedTransactionsTableHeader title="Type" width={15} />
              <RelatedTransactionsTableHeader title="Amount" width={15} />
            </tr>
          </thead>

          <tbody>
            <RelatedTransactionsRows />
          </tbody>
        </table>
      </ErrorBox>
    </PlaceholderBox>
  )
}
